import React from 'react';
import { Box, Button, Card, CardContent, Typography, IconButton } from '@mui/material';
import { Add as AddIcon, Delete as DeleteIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import FormField from './FormField';
import { arrayFieldStyles } from './ArrayField.styles';

const ArrayField = ({ 
  field, 
  value = [], 
  onChange, 
  error, 
  disabled,
  formData = {},
  entityId = null
}) => {
  const { t } = useTranslation();

  const addItem = () => {
    const newItem = {
      id: Date.now(), 
      ...field.defaultItemStructure,
    };
    const newValue = [...value, newItem];
    onChange(field.name, newValue);
  };

  const removeItem = (index) => {
    const newValue = value.filter((_, i) => i !== index);
    onChange(field.name, newValue);
  };

  const updateItem = (index, fieldName, fieldValue) => {
    const newValue = [...value];
    newValue[index] = {
      ...newValue[index],
      [fieldName]: fieldValue,
    };
    onChange(field.name, newValue);
  };

  return (
    <Box sx={arrayFieldStyles.container}>
      <Typography variant="subtitle1" sx={arrayFieldStyles.label}>
        {t(field.label)}
      </Typography>
      
      {value.map((item, index) => (
        <Card key={item.id || index} sx={arrayFieldStyles.proposalCard}>
          <CardContent>
            <Box sx={arrayFieldStyles.proposalHeader}>
              <Typography variant="h6" sx={arrayFieldStyles.proposalTitle}>
                {t(field.itemTitle || 'common.item')} #{index + 1}
              </Typography>
              <IconButton
                onClick={() => removeItem(index)}
                disabled={disabled}
                sx={arrayFieldStyles.deleteButton}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
            
            <hr style={arrayFieldStyles.divider} />
            
            <Box sx={arrayFieldStyles.fieldsContainer}>
              {field.itemFields.map((itemField, fieldIndex) => (
                <FormField
                  key={fieldIndex}
                  field={{
                    ...itemField,
                    name: `${itemField.name}_${index}`,
                    parentItem: item, // Parent item verisini field'a ekle
                  }}
                  value={item[itemField.name]}
                  onChange={(fieldName, fieldValue) => {
                    const actualFieldName = itemField.name;
                    updateItem(index, actualFieldName, fieldValue);
                  }}
                  error={error}
                  disabled={disabled}
                  formData={formData}
                  entityId={entityId}
                />
              ))}
            </Box>
          </CardContent>
        </Card>
      ))}
      
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={addItem}
        disabled={disabled}
        sx={arrayFieldStyles.addButton}
      >
        {t(field.addButtonText || 'common.add')}
      </Button>
    </Box>
  );
};

export default ArrayField;
